// @ts-nocheck
import Section from 'components/Section';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getConversations } from 'actions/access';
import { useParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { teal } from 'api';
import { config } from 'utils/config';
import PenlyAccessUserMessages from './PenlyAccessUserMessages';
import PenlyAccessUserNotes from './PenlyAccessUserNotes';
import PenlyAIAssistent from './PenlyAccessAIAssistent';

const PenlyAccessMessages = ({ penlyUser = {}, sharings, notesOnly = false }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const { organisationId, orderId } = useParams();
    const [messages, setUserMessages] = useState([]);
    const [notes, setUserNotes] = useState([]);
    const [aiConversations, setAiConversations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetch = async () => {
            setLoading(true);
            try {
                const [conversations, order] = await Promise.all([
                    penlyUser?.userId ? dispatch(getConversations(organisationId, penlyUser.userId)) : Promise.resolve([]),
                    orderId ? teal.getOrder(organisationId, orderId) : Promise.resolve(undefined),
                ]);

                const m = conversations?.filter(x => x.audience === 'all')[0]?.messages ?? [];
                const ai = conversations?.filter(x => x.type === 'ai');
                const orderNotes = Array.isArray(order?.notes) ? order.notes : [];

                setUserMessages(m);
                setUserNotes(orderNotes);
                setAiConversations(ai);
            } catch (error) {
                // eslint-disable-next-line no-alert
                alert('Der skete en fejl');
            }
            setLoading(false);
        };

        fetch();
    }, [dispatch, organisationId, orderId, penlyUser?.userId]);

    const canShowConversationSections = !notesOnly && Boolean(penlyUser?.userId);

    return (
        <>
            { config.featureFlags?.raadgiverAi && canShowConversationSections && sharings?.length &&
            <Section title="Rådgiver AI">
                { loading ? (
                    <CircularProgress />
                ) : (
                    <PenlyAIAssistent conversations={ aiConversations } user={ user } penlyUser={ penlyUser }></PenlyAIAssistent>
                ) }
            </Section>
            }

            { orderId && (
                <Section title="Noter">
                    { loading ? (
                        <CircularProgress />
                    ) : (
                        <PenlyAccessUserNotes init={ notes } user={ user } orderId={ orderId }></PenlyAccessUserNotes>
                    ) }
                </Section>
            ) }
            { canShowConversationSections && (
                <Section title="Brugerbeskeder">
                    { loading ? (
                        <CircularProgress />
                    ) : (
                        <PenlyAccessUserMessages init={ messages } user={ user } penlyUser={ penlyUser }></PenlyAccessUserMessages>
                    ) }
                </Section>
            ) }
        </>
    );
};


export default PenlyAccessMessages;
